export enum EVENT_MODAL_STATE {
  CLONE = "clone",
  CREATE = "create",
  EDIT = "edit",
}
